<template>
  <div class="position-relative" v-click-outside="hide">
    <fieldset>
      <input class="form-control my-dropdown" @focus="open" @click="open" readonly v-model="text">
      <img src="/images/arrow_grey.svg" class="my-dropdown-arrow" @click="open">
    </fieldset>
    <div v-if="isVisible">
      <div class="position-absolute adp-dd-options">
        <div class="d-flex flex-column">
          <div class="adp-p adp-dd-option d-flex align-items-center">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" :id="`customCheckMethod`" v-model="allSelected" @change="toggleAll" v-if="hasSelectAll">
              <label class="custom-control-label" :for="`customCheckMethod`">{{ $t('catalog.all') }}</label>
            </div>
          </div>
          <div class="adp-p adp-dd-option" v-for="option in options">
            <div class="custom-control custom-checkbox d-flex align-items-center">
              <input type="checkbox" class="custom-control-input" :id="`customCheckMethod${option.id}`" v-model="selected" :value="option.id">
              <label class="custom-control-label" :for="`customCheckMethod${option.id}`">
                {{ displayedValue(option) }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ActivityTypeSelect',
  props: {
    hasSelectAll: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    initSelected: {
      type: Array,
      default: () => [],
    },
    localize: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selected: this.initSelected,
      allSelected: false,
      indeterminate: false,
      isVisible: false,
      text: '',
    };
  },
  watch: {
    selected(newVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
        this.text = '';
      } else if (newVal.length === this.options.length) {
        this.indeterminate = false;
        this.allSelected = true;
        this.text = this.options.map(element => this.localize ? this.$t(`idp.${element.code}`) : element.code).join(', ');
      } else {
        this.indeterminate = true;
        this.allSelected = false;
        this.text = this.options
          .filter(element => newVal.slice().includes(element.id))
          .map(element => this.localize ? this.$t(`idp.${element.code}`) : element.code)
          .join(', ');
      }
      this.$emit('my-change', this.selected);
    },
  },
  methods: {
    toggleAll(e) {
      this.selected = e.target.checked ? this.options.map(element => element.id) : [];
    },
    hide() {
      this.isVisible = false;
    },
    open() {
      this.isVisible = true;
    },
    displayedValue(option) {
      if (!this.localize) return option.code;
      if (option.wish) return this.$t(`idp.assigned_for_wish`);
      if (option.on_approval) return this.$t(`idp.on_approval_hr`);
      return this.$t(`idp.${option.code}`);
    },
  },
  mounted() {
    this.text = this.options
      .map(element => (this.initSelected.slice().includes(element.id) ? this.$t(`idp.${element.code}`) : false))
      .filter(element => element)
      .join(', ');

  },
};
</script>

<style>

input[readonly].my-dropdown {
  background-color: transparent;
  padding-right: 34px;
  font-size: 14px;
  color: #292929;
}

.my-dropdown-arrow {
  position: absolute;
  display: block;
  top: 50%;
  right: 5px;
  transform: translate(-50%, -50%);
  height: 8px;
}

</style>
